import { render, staticRenderFns } from "./comm-upload-additional.vue?vue&type=template&id=1bf3f751&"
import script from "./comm-upload-additional.vue?vue&type=script&lang=js&"
export * from "./comm-upload-additional.vue?vue&type=script&lang=js&"
import style0 from "./comm-upload-additional.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports